import Navbar2 from "../components/Login/Navbar/Navbar2" 
import Leaderboard from "../components/Categories/body/Leaderboard";
import Categoriess from "../components/Categories/body/Categoriess";


const Categories = () => {
    return(
        <>
        <Navbar2 />
        <Categoriess />
        <Leaderboard />
        </>
    )
}

export default Categories;
